import { request, requestphp, requestzdy, requestocr, requestphptp,requestwx } from "../utils/request";
import qs from "qs";
//const defaultData = { key: "85985868", banben: "v1web", gsbh: "001" };
//const defaultData = { key: "85985868" };
const defaultData = () => {
	let ym = "",
		yhbh = "",
		fid = "",
		mobile = "",
		xiaoshu = "2",
		gsbh = "001";
	let requestOption = JSON.parse(localStorage.getItem("requestOption"));
	let token = JSON.parse(localStorage.getItem("token"));
	fid = localStorage.getItem("fid");
	if (
		JSON.parse(localStorage.getItem("HKStore")) &&
		JSON.parse(localStorage.getItem("HKStore")).common &&
		JSON.parse(localStorage.getItem("HKStore")).common.company
	) {
		xiaoshu = JSON.parse(localStorage.getItem("HKStore")).common.company.xssz1;
	} else {
		xiaoshu = 2;
	}
	//以下是临时过渡
	if (xiaoshu < 2) {
		xiaoshu = 2;
	}
	//临时结束

	if (requestOption && requestOption.yuming) {
		ym = requestOption.yuming;
		mobile = requestOption.mobile;
	}
	if (token && token.username) {
		yhbh = token.username;
	}
	if (token && token.gsbh) {
		gsbh = token.gsbh;
	}
	return {
		key: "85985868",
		ym,
		yhbh,
		// fid:'RSGVIbDhhR3JQ1TjFLOTBaWE4wZkdocmVUZGZkR1Z6ZEh4b2EzazM',
		mobile,
		xiaoshu,
		gsbh,
	};
};
export const HKAPI = (params) => {
	const { key,  yhbh, mobile, fid } = defaultData();
	return request({ method: "get", params: { key,  yhbh, mobile, fid, ...params } });
};
export const HKPOSTAPI = (data) => {
	const { responseType } = data;
	const { key, ym,  yhbh, fid, mobile } = defaultData();
	data = qs.stringify({ key, ym, yhbh, fid, mobile, ...data });
	return request({ method: "post", responseType, data });
};
//ocr
export const HKOCRAPI = (data) => {
	const { mobile } = defaultData();
	const tpurl = "http://" + window.location.hostname + "/api/upload/" + mobile + "/" + data.pic;
	data.tupurl = tpurl;
	// console.log(tpurl);
	const { responseType } = data;
	data = qs.stringify({ ...data });
	return requestocr({ method: "post", responseType, data });
};
//以下是根据ym查询数据库版的api，用于总分店统计。ym通过查询页面传值
export const HKYMAPI = (params) => {
	const { key, gsbh, yhbh, mobile } = defaultData();
	return request({ method: "get", params: { key, gsbh, yhbh, mobile, ...params } });
};
export const HKYMPOSTAPI = (data) => {
	const { responseType } = data;
	const { key, gsbh, yhbh, mobile } = defaultData();
	data = qs.stringify({ key, gsbh, yhbh, mobile, ...data });
	return request({ method: "post", responseType, data });
};
//以下是php版的api，暂时不用
export const HKPHPAPI = (params) => {
	const { key, yhbh, mobile, fid, xiaoshu } = defaultData();
	return requestphp({ method: "get", params: { key, yhbh, mobile, fid, xiaoshu, ...params } });
};

export const HKPHPPOSTAPI = (data) => {
	const { key, ym, yhbh, fid, xiaoshu } = defaultData();
	data = qs.stringify({ key, ym, yhbh, fid, xiaoshu, ...data });
	return requestphp({ method: "post", data });
};

//以下是客户自定义的api，按需求使用
export const HKZDYAPI = (params) => {
	const { key, yhbh, mobile, fid } = defaultData();
	return requestzdy({ method: "get", params: { key, yhbh, mobile, fid, ...params } });
};

//上传图片
export const HKPOSTTPAPI = (data) => {
	const { formData } = data;
	const { type } = data;
	const { key, banben, ym, yhbh, fid } = defaultData();
	const url = { key, banben, ym, yhbh, fid, type, ...data };
	return request({ method: "post", params: url, data: formData });
};
//php上传图片
export const HKPHPTPAPI = (data) => {
	const { formData } = data;
	return requestphptp({ method: "post", data: formData });
};
//微信消息提醒
export const HKPOSTAPIWX = (data) => {
	const { key, ym, yhbh, fid } = defaultData();
	data = qs.stringify({ key, ym, yhbh, fid, ...data });
	return requestwx({ method: "post", data });
};
